import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { ToastContainer, toast } from 'react-toastify'
import { useLocation, useNavigate } from 'react-router-dom'
import BannersApiManager from '../../../api/services/BannersApiManager'
import { isNumber } from '@ant-design/plots/es/core/utils'
import { useTranslation } from 'react-i18next'

function BannerForm() {
    const location = useLocation()
    const { t } = useTranslation()
    const { banner } = location?.state || {}
    const { lastPosition, isEdit } = location?.state || 1
    const [validated, setValidated] = useState(false)
    const [title, setTitle] = useState('')
    const [position, setPosition] = useState(1)
    const [tvImageFile, setTvImageFile] = useState(null)
    const [mobileImageFile, setMobileImageFile] = useState(null)
    const [active, setActive] = useState(true)
    // const [isEditForm, setIsEditForm] = useState(false)
    const [tvImage, setTvImage] = useState(
        '/images/placeholders/placeholder_tv_banner.png'
    )
    const [mobileImage, setMobileImage] = useState(
        '/images/placeholders/placeholder_mobile_banner.png'
    )
    useEffect(() => {
        if (lastPosition && isNumber(lastPosition)) {
            setPosition(lastPosition)
        }

        if(banner){
            setTitle(banner.title);
            setPosition(banner.field_position)
            setTvImage(`https://portal.ok-television.com${banner.field_imagen}`);
            setMobileImage(`https://portal.ok-television.com${banner.field_imagen_para_telefonos_y_ta}`);
            setActive(banner.field_active_banner === "On");
        }
    }, [])

    const navigate = useNavigate()

    const handleSubmit = async (event) => {
        const form = event.currentTarget
        if (form.checkValidity() === false) {
            event.preventDefault()
            event.stopPropagation()
            setValidated(true)
            return
        }

        event.preventDefault()
        setValidated(true)

        let data = {
            title: title,
            field_position: position,
            imageTv: tvImageFile,
            imageMobile: mobileImageFile,
            active: active
        }
        if(location.state.isEdit){
            data.nid = banner.nid;
            var response = await BannersApiManager.editBanner(data);

            if (response) {
                toast.success(t('alerts.banner_edited'))
                navigate(-1)
            } else {
                toast.error(t('alerts.banner_edit_error'))
            }
        }else{
            var response = await BannersApiManager.uploadAndSaveBanner(data)

            if (response) {
                toast.success(t('alerts.banner_created'))
                navigate(-1)
            } else {
                toast.error(t('alerts.banner_create_error'))
            }
        }
        
    }
    return (
        <div className="col-12 grid-margin stretch-card">
            <ToastContainer />
            <div className="card">
                <div className="card-body">
                    <h4 className="card-title">{t('form_title')}</h4>
                    <p className="card-description">
                        {t('form_banner_description')}
                    </p>
                    <Form
                        noValidate
                        validated={validated}
                        onSubmit={handleSubmit}
                    >
                        <Form.Group
                            className="form-group"
                            controlId="validationCustom01"
                        >
                            <Form.Label>{t('name_title')}</Form.Label>
                            <Form.Control
                                type="text"
                                className="form-control"
                                value={title}
                                required
                                onChange={(e) => setTitle(e.target.value)}
                                placeholder={t('name_banner_placeholder')}
                            />
                        </Form.Group>
                        <Form.Group
                            className="form-group"
                            controlId="validationCustom02"
                        >
                            <Form.Label>{t('position_title')}</Form.Label>
                            <Form.Control
                                type="number"
                                className="form-control"
                                value={position}
                                required
                                onChange={(e) => setPosition(e.target.value)}
                                placeholder={t('position_banner_placeholder')}
                            />
                        </Form.Group>

                        <Form.Group className="form-group">
                            <label>
                                {t('form_image_mobile_title')}
                            </label>
                            <div className="custom-file">
                                <Form.Control
                                    type="file"
                                    className="form-control visibility-hidden custom-file-label"
                                    id="fileMobile"
                                    accept="image/*"
                                    onChange={(e) => {
                                        setMobileImageFile(e.target.files[0])
                                        if (e.target.files[0] === undefined) {
                                            return
                                        }
                                        setMobileImage(
                                            URL.createObjectURL(
                                                e.target.files[0]
                                            )
                                        )
                                    }}
                                    required={!isEdit}
                                    lang="es"
                                />
                            </div>

                            <div className="img-preview">
                                <img
                                    src={mobileImage}
                                    alt="Preview Mobile"
                                    className="w-100"
                                    height="400"
                                    style={{ objectFit: 'contain' }}
                                />
                            </div>
                        </Form.Group>

                        <Form.Group className="form-group">
                            <label>{t('form_image_tv_title')}</label>
                            <div className="custom-file">
                                <Form.Control
                                    type="file"
                                    className="form-control visibility-hidden custom-file-label"
                                    id="fileTv"
                                    lang="es"
                                    required={!isEdit}
                                    accept="image/*"
                                    onChange={(e) => {
                                        setTvImageFile(e.target.files[0])
                                        if (e.target.files[0] === undefined) {
                                            return
                                        }
                                        setTvImage(
                                            URL.createObjectURL(
                                                e.target.files[0]
                                            )
                                        )
                                    }}
                                />
                            </div>
                            <div className="img-preview">
                                <img
                                    src={tvImage}
                                    alt="Preview TV"
                                    height="400"
                                    width="100%"
                                    style={{ objectFit: 'contain' }}
                                />
                            </div>
                        </Form.Group>

                        <Form.Group
                            className="form-group"
                            controlId="validationCustom03"
                        >
                            <Form.Label>{t('active_title')}</Form.Label>
                            <Form.Check
                                type="switch"
                                name="active"
                                id="activeSwitch"
                                checked={active}
                                onChange={(e) => {
                                    setActive(e.target.checked)
                                }}
                            />
                        </Form.Group>
                        <Button
                            variant="btn btn-primary"
                            className="me-2"
                            type="submit"
                        >
                            {t('button.save')}
                        </Button>
                        <Button
                            variant="btn btn-light"
                            onClick={() => navigate(-1)}
                        >
                            {t('button.cancel')}
                        </Button>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default BannerForm
